import React from "react"

import { connect } from "scrivito"

import { ProjectPageProductPositionSidebar } from "./ProjectPageProductPositionSidebar"
import {
  UseProjectPageProductPositionSidebarModelArgs,
  useProjectPageProductPositionSidebarModel
} from "./hooks/useProjectPageProductPositionSidebarModel"

function ProjectPageProductPositionSidebarConnectorComponent(
  props: UseProjectPageProductPositionSidebarModelArgs
) {
  return (
    <ProjectPageProductPositionSidebar
      {...useProjectPageProductPositionSidebarModel(props)}
    />
  )
}
export const ProjectPageProductPositionSidebarConnector = React.memo(
  connect(ProjectPageProductPositionSidebarConnectorComponent)
) as typeof ProjectPageProductPositionSidebarConnectorComponent
